import React from "react";
import { motion } from "framer-motion";
import "./WSPLoadingSkeleton.css";

/**
 * WSPLoadingSkeleton - Loading State Component
 */
const WSPLoadingSkeleton = ({ count = 6, viewMode = "grid" }) => {
  const isListView = viewMode === "list";

  return (
    <div className={`wsp-loading-grid ${isListView ? "wsp-loading-list" : ""}`}>
      {Array.from({ length: count }).map((_, index) => (
        <motion.div
          key={index}
          className="wsp-skeleton-card"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: index * 0.05 }}
        >
          <div className="wsp-skeleton-image">
            <div className="wsp-skeleton-shimmer" />
          </div>
          <div className="wsp-skeleton-content">
            <div className="wsp-skeleton-category" />
            <div className="wsp-skeleton-title" />
            <div className="wsp-skeleton-title wsp-skeleton-title-short" />
            <div className="wsp-skeleton-meta">
              <div className="wsp-skeleton-meta-item" />
              <div className="wsp-skeleton-meta-item" />
            </div>
            <div className="wsp-skeleton-footer">
              <div className="wsp-skeleton-stats" />
              <div className="wsp-skeleton-button" />
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default WSPLoadingSkeleton;
